import { api } from './client.js';

const unwrap = (resp) => resp.data?.data;

export const finApi = {
  // CoA
  accountCategories: () => api.get('/accounts/categories').then(unwrap).then((d) => d?.items || []),
  // Callers expect an array; unwrap the {items} envelope here.
  accounts: (params) => api.get('/accounts', { params }).then(unwrap).then((d) => d?.items || []),
  accountTree: () => api.get('/accounts/tree').then(unwrap),
  createAccount: (payload) => api.post('/accounts', payload).then(unwrap),
  updateAccount: (id, patch) => api.patch(`/accounts/${id}`, patch).then(unwrap),
  archiveAccount: (id) => api.delete(`/accounts/${id}`).then(unwrap),

  // Periods
  periods: () => api.get('/periods').then(unwrap),
  closePeriod: (id) => api.post(`/periods/${id}/close`).then(unwrap),
  openPeriod: (year, month) => api.post('/periods', { year, month }).then(unwrap),

  // Journal
  listJournalEntries: (params) => api.get('/journal-entries', { params }).then(unwrap),
  getJournalEntry: (id) => api.get(`/journal-entries/${id}`).then(unwrap),
  createJournalEntry: (payload) => api.post('/journal-entries', payload).then(unwrap),
  postJournalEntry: (id) => api.post(`/journal-entries/${id}/post`).then(unwrap),

  // Ledger
  ledger: (params) => api.get('/ledger', { params }).then(unwrap),

  // Vendors
  vendors: (params) => api.get('/vendors', { params }).then(unwrap),
  createVendor: (payload) => api.post('/vendors', payload).then(unwrap),
  vendorInvoices: (params) => api.get('/vendor-invoices', { params }).then(unwrap),
  createVendorInvoice: (payload) => api.post('/vendor-invoices', payload).then(unwrap),
  voidVendorInvoice: (id) => api.post(`/vendor-invoices/${id}/void`).then(unwrap),

  // Customers
  customers: (params) => api.get('/customers', { params }).then(unwrap),
  createCustomer: (payload) => api.post('/customers', payload).then(unwrap),
  customerInvoices: (params) => api.get('/customer-invoices', { params }).then(unwrap),
  getCustomerInvoice: (id) => api.get(`/customer-invoices/${id}`).then(unwrap),
  createCustomerInvoice: (payload) => api.post('/customer-invoices', payload).then(unwrap),
  generateCustomerInvoicePdf: (id) => api.post(`/customer-invoices/${id}/pdf`).then(unwrap),

  // Payments
  payments: (params) => api.get('/payments', { params }).then(unwrap),
  recordPayment: (payload) => api.post('/payments', payload).then(unwrap),
  aging: (type, asOf) => api.get('/payments/aging', { params: { type, as_of: asOf } }).then(unwrap),

  // Budgets
  budgets: (params) => api.get('/budgets', { params }).then(unwrap),
  getBudget: (id) => api.get(`/budgets/${id}`).then(unwrap),
  createBudget: (payload) => api.post('/budgets', payload).then(unwrap),
  upsertBudgetLine: (id, payload) => api.put(`/budgets/${id}/lines`, payload).then(unwrap),
  budgetVsActual: (id) => api.get(`/budgets/${id}/vs-actual`).then(unwrap),

  // Banking
  bankAccounts: () => api.get('/banking/accounts').then(unwrap),
  createBankAccount: (payload) => api.post('/banking/accounts', payload).then(unwrap),
  bankTransactions: (params) => api.get('/banking/transactions', { params }).then(unwrap),
  importBankTransactions: (bankAccountId, items) => api.post('/banking/transactions/import', { bankAccountId, items }).then(unwrap),
  reconcile: (matches) => api.post('/banking/reconcile', { matches }).then(unwrap),

  // Reports
  profitLoss: (dateFrom, dateTo) => api.get('/reports/profit-loss', { params: { date_from: dateFrom, date_to: dateTo } }).then(unwrap),
  balanceSheet: (asOf) => api.get('/reports/balance-sheet', { params: { as_of: asOf } }).then(unwrap),
  cashFlow: () => api.get('/reports/cash-flow').then(unwrap),
};
